<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-icon
        size="16"
        color="black"
        @click.stop="$emit('pasteContent')"
        v-on="on">
        mdi-content-paste
      </v-icon>
    </template>
    <span>Paste content</span>
  </v-tooltip>
</template>
<script>
export default {
  name: 'ProductCellPaste',
};
</script>